export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
  login: {
    signUp:'اشتراك',  
    title: 'محفظة عالمية لجميع أصولك الرقمية.',
    submit: 'تسجيل الدخول',
    username: 'يرجى إدخال رقم الهاتف الخاص بك',
    password: 'من فضلك أدخل رقمك السري',
    verifycode:'الرجاء إدخال كلمة التحقق',
    forget_password:'نسيت رقمك السري؟',
	no_account:'ليس لديك حساب AuWallet؟',
    register:'يسجل',
    verifycode_tip:'الرجاء إدخال كلمة التحقق',
    verifycode_error:'كلمة التحقق غير صالحة'
  },
  register:{
    title:'يسجل',
    username:'رقم التليفون',
    get_code:'الحصول على رمز',
    verifycode:'رمز التحقق',
    password:'كلمة السر',
    repeat:'بالتاكيد',
    invite_code:'اتصل بالرقم',
    submit:'يسجل',
    registered:'لديك حساب بالفعل',
    go_login:'اذهب وسجل الدخول'
  },
  nologin:{
    cloud_wallet:'المحفظة السحابية',
    cloud1:'أعلى حماية أمنية',
    cloud2:'كسب الأصول الفريدة وتسجيل وإيداع العملات المعدنية للتمتع بالدخل',
    cloud3:'دعم أكثر من 30 قطعة نقدية رئيسية وأكثر من 500 رمز مميز',
    button1:'يسجل',
    button2:'تسجيل الدخول',
    button_oauth:'تسجيل الدخول باستخدام 2U.Chat',
    hd_wallet:'HD المحفظة',
    hd1:'تحكم بنسبة 100٪ في المفاتيح الخاصة ، وأصول أكثر ضمانًا',
    hd2:'بنقرة واحدة استيراد الكلمات ذاكري ، مريحة وسهلة الاستخدام',
    hd3:'دعم أكثر من 30 قطعة نقدية رئيسية وأكثر من 500 رمز مميز',
    button3:'يسجل',
    button4:'تسجيل الدخول',
    doLogin:"انقر لتسجيل الدخول",
    welcomeTo:"مرحبًا بك في AuWallet",
  },
  forget:{
    title:'هل نسيت كلمة السر؟',
    phone_number:'رقم التليفون',
    verify_code:'رمز التحقق',
    password:'كلمة المرور',
    repeat:'كرر مرة أخرى',
    submit:'تؤكد'
  },
  footer:{
    nav1:'محفظة نقود',
    nav2:'سوق',
    nav3:'أصل',
    nav4:'يكتشف',
    nav5:'لي'
  },
  home:{
    total:'إجمالي الأصول',
    invite:'ادعو أصدقاء',
    redbag:'أرسل حزمة حمراء',
    exchange:'تبادل',
    scan:'مسح',
    address_book:'دليل العناوين',
    notice:'إشعارات',
    setting:'جلسة',
    view_mnemonic:'',
    backup_mnemonic:'مشاهدة ملف Mnemonic',
    create_wallet:'إنشاء المحفظة',
    import_wallet:'استيراد المحفظة', 
    welcome:'أهلا بك',
	cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
  },
  
  address:{
    new_address:'عنوان جديد',
    name:'اسم',
    address:'تبوك',
    submit:'خلق',
	warning_msg: ' ملاحظة : هذا العنوان يمكن فقط الحصول على رمز erc20 ، يرجى التأكد من عدم اختيار القناة الخطأ عند نقل .'
  },
  swap:{
    title:'مبادلة فلاش',
    pay:'يجب أن تدفع',
    balance:'الرصيد المتوفر',
    lock_rate:'يرجى إكمال السداد في غضون الوقت التالي لتأمين سعر الصرف هذا',
    gain:'سوف تحصل على',
    input:'الرجاء إدخال المبلغ',
    tip:'عندما تكون العملة التي تحصل عليها فارغة ، فهذا يعني أنه لا توجد عملة لمبادلة فلاش',
    submit:'مبادلة الآن',
    choose_coin:'اختر عملة',
	notice_2ut:'لقد قرأت هذا الإشعار'
  },
  coin:{
    send:'إرسال',
    swap:'مبادلة، مقايضة',
    receive:'تسلم',
    transactions:'تسلم',
    type1:'سحابة',
    type2:'سحابة في',
    type3:'مبادلة، مقايضة',
    type4:'مالي',
    type7:'HD خارج',
    type8:'HD في',
    type9:'أرسل حزمة حمراء',
    type10:'قبول الحزمة الحمراء',
	type11:'AuWallet transfer out TimeEx',
	type12:'TimeEx transfer in AuWallet',
	type13: 'Chain shopping service fee',
	type14: '10% Off shopping service fee',
	type15: 'Withdrawal',
	type16: 'KYC Certification fees',
    flushing:'تدفق مائى - صرف...',
    loading:'جار التحميل...',
    no_records:'لا تسجيلات',
    wallet:'محفظة نقود',
    tx_time:'وقت المعاملة',
    tx_id:'بطاقة تعريف',
    tx_from:'من',
    tx_to:'ل',
    tx_memo:'ملاحظة',
    tx_status1:'فشل',
    tx_status2:'انتظار',
    tx_status3:'نجاح',
    tx_status4:'ريثما',

    receive_address:'الرجاء إدخال عنوان الاستلام',
    balance:'الرصيد',
    fee:'مصاريف',
    send_all:'أرسل الكل',
    gas_fee:'رسوم الغاز',
    slow:'بطيء',
    fast:'سريع',
    send:'إرسال',
    tx_password:'الرجاء إدخال كلمة مرور الدفع',
    tx_remark:'ملاحظات (اختياري)',
    address_book1:'دفتر عناوين السحابة',
    address_book2:'HD دفتر العناوين',
    need_pay_pass:'يرجى تعيين كلمة مرور الدفع أولاً',
    need_pin:'يرجى الذهاب إلى المركز الشخصي لتعيين الرقم السري',

    
    set_receive_amount:'تعيين مبلغ الاستلام',
    receive_amount:'استلام المبلغ',
    copy_receive_code:'نسخ كود الدفع',
    confirm:'يتأكد',
    cancel:'يلغي',
    rcv_address:'عنوان الاستلام',
    search:'أدخل محتوى البحث',
    filter:'منقي',
    remove:'منقي',
    add:'يضيف',

    filter1:'جميع العملات',
    filter2:'مضاف',
    filter3:'غير مضافة',
    
    notices:'إشعارات محفظة HD',
    notices2:'إشعارات المحفظة السحابية',
	only_bitcoin: 'نقل فقط BITCOIN',
	only_eth: 'نقل فقط TEH',
	only_usdt: 'نقل فقط USDT',
	only_2ut: 'نقل فقط 2UT',
	only_u2u: 'نقل فقط U2U',
	only_2u: 'نقل فقط 2U',
	only_a2u: 'نقل فقط A2U',
	import: 'Import',
	info: 'Token overview'
  },

  market:{
    title:'سوق',
    coin:'أصل',
    volume:'الصوت',
    price:'السعر',
    change:'التغيير (24 ساعة)',
  },

  discover:{
    title:'يكتشف',
    popular:'شائع',
    all:'الجميع'
  },

  my:{
    title:'لي',
    notice:'إشعارات',
    login:'انقر لتسجيل الدخول',
    welcome:'مرحبًا بك في AuWallet',
    invite:'مكافأة الدعوة',
    news:'التعبير اليومي',
    contact:'خدمة الزبائن',
    pin_on:'تشغيل',
    pin_off:'إيقاف',
    default_currency:'العملة الافتراضية',
    red_green:'خيارات الاقتباس',
    option1:'أخضر حتى أحمر أسفل',
    option2:'أحمر حتى أخضر أسفل',
    contract:'اتفاقية خدمات',
    privacy:'سياسة الخصوصية',
    help:'مركز المساعدة',
	invite: 'My Invite code',
	onequan: 'My Business Circle',
	copy: 'Copy',
	total: 'Total',
	downloadapp: 'Download mobile APP.',
	download: 'Download',
	waiting: 'Waiting Or Use',
	greenxv: 'GreenX Vcode',
	greenxvet: 'Can use'
  },
  setup:{
    title:'إعداد المحفظة',
    pay_password:'دفع كلمة المرور',
    on:'جوعان',
    off:'إيقاف',
    google:'التحقق من جوجل',
    security_level:'مستوى الأمان',
    account_name:'أسم الحساب',
    logout:'تسجيل خروج',
    register_time:'وقت التسجيل',
    level:'مستوى',
    modify_pay_password:'تعديل كلمة مرور الدفع',
    reset_pay_password:'إعادة تعيين كلمة مرور الدفع',
    reset_tip:'لأمان حسابك ، يرجى إدخال كلمة المرور الأصلية للدفع لتأكيد هويتك',
    forget_pay_password:'نسيت كلمة مرور الدفع',
    set_pay_password:'تعيين كلمة مرور الدفع',
    enter_password:'الرجاء إدخال كلمة المرور',
    enter_password2:'الرجاء إدخال مرة أخرى',
    vcode:'رمز التحقق',
    submit:'يتأكد',
    pay_password_wrong:'كلمة المرور التي أدخلتها غير صحيحة',
    fontSize:'حجم الخط'

  },
  news:{
    title:'التعبير اليومي',
    share:'شارك',
    good:'حسن',
    bad:'سيئة',
  },
  pin:{
    title:'قم بتعيين رمز PIN',
    desc1:'من أجل حماية أمن الأصول الخاصة بك ، يرجى تعيين رمز PIN أولاً ، سيتم استخدام رمز PIN لفتح المحفظة وإرسال العملات المعدنية',
    desc2:'رمز PIN هو كلمة مرور محلية ، يرجى الاحتفاظ بها بشكل صحيح ، في حالة فقدها ، لا يمكن استعادتها',
    close:'قم بإيقاف تشغيل رمز PIN',
    title2:'تحقق من رقم التعريف الشخصي',
    tip2_1:'هل نسيت رمز PIN الخاص بك؟ بعد عمل نسخة احتياطية من المحفظة ، أعد تثبيت التطبيق وأعد الضبط بعد استيراد عبارة ذاكري'
  },
  google:{
    title:'التحقق من جوجل',
    tip:'يمكن أن تضيف ميزة التحقق بخطوتين من Google طبقة حماية لحسابك. عند تسجيل الدخول أو إجراء معاملة ، عند إدخال كلمة المرور الخاصة بك ، فإنك تحتاج أيضًا إلى رمز التحقق من التحقق المكون من خطوتين',
    help:'كيفية استخدام التحقق من خطوتين من Google',
  },
  security:{
    title:'مستوى الأمان',
    title2:'مستوى الأمان',
    tip:'من أجل سلامة أموالك ، تحتاج إلى مزيد من إعدادات الأمان ومعلومات الاسم الحقيقي قبل أن تتمكن من سحب العملات المعدنية ، وسيزيد حد السحب وفقًا لذلك',
    l3title:'حدد نوع الوثيقة',
    l3tip:'الرجاء تحديد بلد إصدار شهادتك',
    c1:'أمريكا',
    c2:'البر الرئيسى للصين',
    c3:'الصين هونغ كونغ وماكاو وتايوان',
    c4:'كوريا الجنوبية',
    c5:'اليابان',
    c6:'سنغافورة',
    c7:'آخر',
    nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
  },
  realname:{
    title:'معلومات الشهادة',
    tip:'يتطلب منك AuWallet تقديم بطاقة هوية تحمل صورة صادرة عن الحكومة لاجتياز التحقق الأمني',
    subtitle1:'نموذج اشتراك 2U Token (2UT)',
    country:'دولة',
    country_hint:'بلد إقامتك',
    firstname:'الاسم الاول',
    firstname_hint:'اسمك الأول',
    surname:'اسم العائلة',
    surname_hint:'اللقب الخاص بك',
    birthdate:'عيد ميلاد',
    cert_id:'رقم الهوية',
    cert_id_hint:'رقم الهوية الخاصة بك',
    id_photo1:'صورة الهوية الأمامية',
    id_photo2:'معرف صورة عكسية',
    address:'تبوك',
    address_hint:'إقامتك الحالية',
    addr_photo:'إثبات العنوان',
    asset_photo:'إثبات الأصول',
    subtitle2:'شهادة تأهيل المستثمر',
    tip1:'أؤكد أنني استوفي واحدًا على الأقل من المعايير التالية وتم اعتمادي كمستثمر مؤهل من قبل المُصدر (إن أمكن ، يمكن اختيار أكثر من واحد)',
    tip2:'ملاحظة (1): تشير محفظة الاستثمار إلى الأوراق المالية والنقدية ، باستثناء العقارات',
    tip3:'ملاحظة (2): يجب إرفاق المستندات التي تحتوي على كشف حساب شهري ، وملخص حسابي ، وما إلى ذلك في الأشهر الثلاثة الماضية',
    invest_exp:'خبرة في الاستثمار',
    other_exp:'آخر',
    avg_volume:'الصوت',
    avg_volume_hint:'متوسط حجم المعاملات في آخر 12 شهرًا (بالدولار الأمريكي)',
    avg_num:'عدد',
    avg_num_hint:'متوسط عدد المعاملات في آخر 12 شهرًا',
    exp_year:'سنوات الاستثمار',
    exp_year_hint:'كم عدد سنوات الخبرة في الاستثمار',
    net_asset:'صافي الموجودات',
    net_asset_hint:'صافي قيمة الأصول (بالدولار الأمريكي)',
    risk_tolerance:'تحمل المخاطر',
    invest_term:'مصطلح الاستثمار المثالي',
    derivative:'المشتقات',
    signature:'إمضاء',
    reset:'إعادة ضبط',
    phone_number:'رقم التليفون',
    submit:'إرسال',
    option1_1:'مستثمرون أفراد أو مستثمرون من الأفراد من أصحاب الثروات العالية ولديهم محفظة نقدية و / أو أوراق مالية لا تقل عن 20000 دولار أمريكي (أو ما يعادلها) في حساب مشترك مع أزواجهم أو أطفالهم',
    option1_2:'لا تقل المحفظة الاستثمارية للشركة أو الشراكة عن 20.000 دولار أمريكي أو أن إجمالي الأصول لا يقل عن 2 مليون دولار أمريكي',
    option1_3:'يقوم المستثمرون الأفراد أو الشركات أو الشراكات من أصحاب الثروات العالية بفتح حساب لدى De La O RuralBank Inc. ولديهم ما لا يقل عن 20000 دولار أمريكي في وقت توقيع نموذج التقييم هذا',
    option2_1:'ضمانات',
    option2_2:'العقود الآجلة',
    option2_3:'وضع',
    option2_4:'غير ذلك (يرجى التحديد)',
    option3_1:'متوسط',
    option3_2:'وسط',
    option3_3:'قليل',
    option4_1:'أكثر من 3 سنوات',
    option4_2:'1-3 سنوات',
    option4_3:'أقل من 1 سنة',
    option5_1:'نعم',
    option5_2:'رقم'
  },
  envelope:{
    title:'مغلف أحمر',
    owned:'مغلفي',
    amount:'مقدار',
    quantity:'كمية',
    quantity_hint:'كمية المغلف',
    generate:'يولد',
    title2:'أرسل مغلف',
    total:'المبلغ الإجمالي للمغلف الأحمر',
    wishes:'التمنيات',
    submit:'دفع',
    enter_pass:'الرجاء إدخال كلمة مرور الدفع',
    choose_path:'اختر طريقة التوصيل',
    view:'عرض تفاصيل المغلف الأحمر',
    choose_coin:'اختر عملة',
    need_pay_password:'يرجى تعيين كلمة مرور الدفع أولاً',
    share:'شارك المغلف الأحمر مع أصدقائك',
    title3:'سجلات المغلف الأحمر',
    num:'كمية',
  },
  mnemonic:{
    title:'نسخة احتياطية من ذاكرة المحفظة',
    tip:'إن ذاكري هو المفتاح الخاص ، وهو مفتاح التحكم في ملكيتك',
    tip1:'1. يتكون من 12 حرفًا ، يرجى نسخه والاحتفاظ به في مكان آمن.',
    tip2:'2. سيتم الاحتفاظ بنسبة 100٪ بواسطتك ، بمجرد فقدها ، لا يمكن استرجاعها.',
    tip3:'3. يرجى التأكد من إكمال النسخة الاحتياطية من عبارة ذاكري قبل استلام العملة أو إلغاء تثبيتها.',
    backup:'اعمل نسخة احتياطية الان',
    later:'افعله لاحقا',
    tip4:'من فضلك انظر حولك',
    tip5:'أي شخص يحصل على ذاكري يعني أنه حصل على الأصول الخاصة بك. يرجى التأكد من عدم وجود أحد ولا كاميرات.',
    understand:'مفهوم',     
    title2:'مشاهدة ملف Mnemonic',
    tip6:'يمكنك استيراد عبارة ذاكري للإقران على أجهزة أخرى ، أو استخدام محفظة AuWallet على أجهزة أخرى لمسح رمز الاستجابة السريعة للإقران.',
    tip7:'من فضلك لا تأخذ لقطة! إذا حصل شخص ما على عبارة ذاكري الخاصة بك ، فسيحصل على أصولك مباشرة!',
    view_code:'عرض رمز الاستجابة السريعة المشفر',
    tip8:'إن تشفير رمز الاستجابة السريعة هو لتسهيل اقتران المحفظة بأجهزة جديدة. يرجى عدم التقاط لقطات الشاشة وحفظها ، والتأكد من عدم وجود أشخاص آخرين حولك أو وجود كاميرات خفية.',
    tip9:'لا يمكن استخدام رمز الاستجابة السريعة هذا إلا بواسطة محافظ الاتحاد الأفريقي. عند المسح ، تحتاج إلى إدخال رمز PIN للتطبيق الحالي في التطبيق المراد استيراده لاستيراد ذاكري المقابل بنجاح.',

    title3:'يرجى نسخ AuWallet ذاكري',
    tip3_1:'تستخدم عبارة AuWallet ذاكري لاستعادة المحفظة. يرجى نسخ الكلمات الـ 12 التالية على الورق بالترتيب وحفظها في مكان آمن.',
    tip3_2:'من فضلك لا تأخذ لقطة! إذا حصل شخص ما على عبارة ذاكري الخاصة بك ، فسيحصل على أصولك مباشرة!',
    save:'لقد حفظتها بأمان',

    title4:'يرجى تأكيد عبارة AuWallet ذاكري',
    tip4_1:'للتأكد من أنك قمت بنسخ كلمات ذاكرة AuWallet بشكل صحيح ، يرجى تحديد الكلمة المقابلة للرقم التسلسلي.',
    finish:'ينهي',
    next:'التالي',
    verror:'خطئ في التحقق',

    title5:'استعادة Mnemonic Wallet',
    tip5_1:'الرجاء إدخال الكلمات التذكرية في النموذج أدناه للرد على المحفظة. بعد إدخال كل كلمة ذاكري ، اضغط على مفتاح "مسافة" للانتقال إلى الكلمة التالية',
    recover:'ابدأ الانتعاش',
    ask:'هل تريد الكتابة فوق المحفظة الحالية؟',
    tip5_2:"سيؤدي استيراد محفظة إلى استبدال المحفظة الحالية. إذا لم تقم بالنسخ الاحتياطي حتى الآن ، فستختفي المحفظة الحالية إلى الأبد.",
    tip5_3:'لقد قمت بعمل نسخة احتياطية من محفظتي الحالية وأوافق على الكتابة فوقها',
    cancel:'يلغي',
    import:'استمر في الاستيراد',
    agree:'الرجاء اختيار الموافقة',
    create_success:'تم إنشاؤه بنجاح',
    complete:'من فضلك املأ كامل ذاكري',
  },
  invite:{
    title:'دعوتي',
    total:'رقم الدعوة',
    invite_num:'عدد الأصدقاء المسجلين',
    bonus1:'1-مستوى الأصدقاء',
    every:'للشخص الواحد',
    bonus2:'2-المستوى الأصدقاء',
    bonus3:'3 مستويات الأصدقاء',
    deposit:'عدد الأصدقاء الذين قاموا بإيداع العملات المعدنية',
    list:'قائمة المدعوين',
    subtitle1:'تسجيل',
    subtitle2:'الوديعة',
    no_records:'لا دعوة حتى الان'
  },
  lang:{
    set_lang:'لغة مجموعة',

  },
  setting:{
    tip:'يتم تداول النظام فعليًا بالدولار الأمريكي ، ويقوم النظام تلقائيًا بتحويل سعر عمولة المستخدم إلى الدولار الأمريكي بأحدث سعر صرف. قد يختلف سعر العمولة الفعلي قليلاً عن سعر إدخال المستخدم'
  },
  send:{
    title:'نوع التحويل',
    t1:'تحويل Blockchain',
    t2:'التحويل الداخلي',
  },
  sortable:{
    title:'فرز مخصص',
    drag_to_sort:'اسحب للترتيب',
    currency:'عملة'
  },
  system:{
    flushing:'تدفق مائى - صرف...',
    loading:'جار التحميل...',
    btn1:'يتأكد',
    btn2:'يلغي',
    add:'يضيف',
    search:'بحث',
    topPullText:'للتحديث اسحب للأسفل',
    topDropText:'الافراج عن التحديث',
    topLoadingText:'جار التحميل...',
    copy_succ:'نسخ بنجاح',
    copy_fail:'فشل النسخ',
    about:'About'
  },
  share:{
    title:'شارك',
    download:'امسح الكود لتنزيل AuWallet',
    sharecode:'رمز الدعوة (انقر للنسخ):',
    view_invites:'عرض تفاصيل الدعوة',
    copy_link:'نسخ الوصلة',
    attention:'انسخ الرابط أعلاه والصقه في متصفح هاتفك المحمول وافتحه لتنزيل AuWallet.'
  },
  wealth:{
    tit:"أصول",
    title:'ثروتي',
    title1:'التعدين',
    title2:'خطة العملة',
    hot:'التوصية الشعبية',
    plan1:'خطة حسب الطلب',
    plan2:'خطة ثابتة',
    annu_return:'العائد السنوي',
    in_amount:'كمية في',
    transfer_all:'الكل',
    view_rules:'عرض القواعد',
    pay_password:'الرجاء إدخال كلمة مرور الدفع',
    asset:'ثروة',
    search:'الاستعلام عن المعاملات',
    rules:'قواعد',
    order_time:'وقت الطلب',
    value_date:'تاريخ القيمة',
    expiry_date:'تاريخ الانتهاء',
    highlights:'يسلط الضوء',
    remaining_quota:'الحصة المتبقية',
    buy:'اشتري الآن',
    ystday_earnings:"أرباح الأمس",
    total_earnings:'الأرباح الكلية',
    transfer_in:'في',
    transfer_out:'خارج',
	transfer_outed:' الفداء',
    tran_all:'الكل',
    tran_in:'في',
    tran_out:'خارج',
    tran_earning:'كسب الدخل',
    prod_all:'الكل',
    prod1:'التعدين PoS',
    prod2:'خطة العملة',
    curr_all:'الكل',
    out_amount_tip:'الرجاء إدخال مبلغ التحويل',
    send:'إرسال',
    success:'نجاح',
    amount_tip:'الرجاء إدخال مبلغ'
  },
  ads:{
    title:'أخبار جيدة',
    content:'يتم قطع مخزون U2U',
    content2:'2UT Hot selling...',
    buy:'يشترى',
    plan_name:'U2U إصدار جديد',
    tip: 'U2U is 10% off!'

  },
  buyuut: {
    maxtip: 'Each person can buy a maximum of 100',
    current: 'Current',
    price: 'Price',
    discount: 'Discount',
    off: 'OFF',
    amountlabel: 'Purchase quantity',
    maxerror: 'You can\'t buy more than 100',
    totalprice: 'Total Price',
    balance: 'Balance',
    purchase: 'Purchase',
    rulestitle: 'Rules of Activity'
  },
  receive:{
	  fuzhicg:'نسخ بنجاح ',
	  fuzhicc:'نسخ فشلت ',
  },
  alert:{
  	  cancel:' ألغى',
  	  confirm:' أكّد '
  },
  against:{
		  no100: ' usdt يجب أن تكون متعددة من 100 '
	},
	package:{
		  title: 'لف',
		  amount: 'الكمية',
		  time: 'الوقت ',
		  coin: 'عملة معدنية',
		  price: 'الأسعار',
		  scale: 'مقياس',
		  quantity: 'كمية',
		  submit: 'قدم',
		  total: 'كامل',
		  points: 'نقطة',
		  balance: 'التوازن',
		  apoints: 'التوازن',
		  apoints2: 'الدخل المتاح من الثروة ',
		  abalance: 'الرصيد المتاح',
		  abalance2: 'الرصيد المتاح',
		  import: 'استيرادها',
		  orders: 'أمر',
		  orders_detail: 'تفاصيل النظام',
		  defi: 'DEFI',
		  nopoint: 'تبادل أكثر من النقاط المتاحة',
		  nobalance: 'استبدال أكثر من الرصيد المتاح',
		  nologin: 'تسجيل الدخول قد انتهت ، يرجى تسجيل الدخول مرة أخرى .',
		  pay_type: 'نوع الدفع'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
}
